import { DATA_GIF_PATH } from "@/app/utils/config";
import { useNavigate } from "react-router-dom";

interface SuccessfulProps {
  onContinue: () => void;
}

const SuccessfulPage: React.FC<SuccessfulProps> = ({ onContinue }) => {
  const navigate = useNavigate();

  // ...............................handleLogin..............................
  const handleLogin = () => {
    navigate("/dashboard/admin-menu");
  };
  // .....................................UI.....................................
  return (
    <>
      <div className="gx-bankdetails-card">
        <div className="gx-change-password">
          <div className="gx-login-card">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="gx-login-success-img">
                  <img
                    src={`${DATA_GIF_PATH}done_animation.gif`}
                    alt="Success"
                  />
                </div>
              </div>
              <div className="col-span-12">
                <div className="gx-login-success-title">
                  <h2 className="gx-h2-l">
                    Bank Account{" "}
                    <span className="gx-h2-b">Created Successfully!</span>
                  </h2>
                  <p className="gx-p12-sb">
                    Your bank account has been created successfully. You can now
                    log in using your email and new password.
                  </p>
                </div>
              </div>
              <div className="col-span-12">
                <div className="login-continue-btn">
                  <button className="gx-p16-eb" onClick={handleLogin}>
                    Dashboard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessfulPage;
